
import _ from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import numeral from 'numeral'
import moment, { unitOfTime } from 'moment'
import { telPhone } from '@/services/Helpers'

@Component
export default class VueExtendedBaseComponent extends Vue {

  @Action('components/updateSnackbar')
  public updateSnackbar!: (data: {
    txt: string
    type: 'success' | 'error',
  }) => void

  @Action('components/pageStartLoading')
  public pageStartLoading!: () => void

  @Action('components/pageStopLoading')
  public pageStopLoading!: () => void

  @Getter('userprofile/permissions')
  public permissions: {[permission: string]: boolean}

  @Getter('components/level')
  public level!: {
    id?: string,
    mode: string,
  }

  public validateList = {
    number: { reg: /^[0-9]+$/, msg: 'ต้องเป็นตัวเลข 0-9' },
    double: { reg: /^[0-9]+.[0-9]+$/, msg: 'ต้อง' },
    email: { reg: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})/, msg: 'อีเมล์ไม่ถูกต้อง'},
    password: { reg: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[.-_ *@!])[0-9a-zA-Z.-_ *@!]{8,}$/, msg: 'Must be contain at least 8 characters, Uppercase(A-Z) and lowercase(a-z) and special character(.-_ *@!) and Digit(0-9) at lease 1'},
    phone: { reg: /^(0)[1-9]{1}[0-9]{8}$/, msg: 'หมายเลขโทรศัพท์จะต้องเริ่มด้วย 0, จากนั้นตามด้วยเลข 9 ตัว'},
    cid: { reg: /^[1-8]{1}[0-9]{11}[0-9]{1}$/, msg: 'หมายเลขบัตรประชาชนไม่ถูกต้อง' },
    url: { reg: /^(http|https):\/\/([a-z0-9-]{1,})([.][a-z0-9-]{1,}){1,}[\/]?$/, msg: 'URL must start with http or https'},
    domain: { reg: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,48}[a-zA-Z0-9]\\.[a-zA-Z]{2,}$/, msg: 'Domain or Sub Domain was wrong'},
    ipv4: { reg: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, msg: 'IPv4 specs was wrong'},
    cidr: {
      reg: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[1-2][0-9]|3[0-2]))$/,
      msg: 'IPv4 specs with netmask was wrong',
    },
    json: { reg: /^[\x00-\x7F]+$/, msg: 'Input must be in JSON format'},
    date: { reg: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/, msg: 'วันที่ไม่ถูกต้อง'},
  }

  public mapPermission(key: string, type: string) {
    return `${key}::${this.level.mode}::${type}`
  }

  public telPhone(phone: string) {
    telPhone(phone)
  }

  public numeral(num: number | string, format: string = '0,0[.]00') {
    return numeral(num).format(format)
  }

  public nameValidate(name) {
    return /[ -~ก-๙]/g.test(name) || false
  }

  public mapFullName(data: {prefix?: string, firstname: string, lastname: string}) {
    return `${data.prefix || ''}${data.firstname} ${data.lastname}`
  }

  public removePrefix(txt: string, prefix: string) {
    const hasPrefix = txt.indexOf(prefix) === 0
    return hasPrefix ? txt.substr(prefix.length) : txt
  }

  public countDate(startDate: string, endDate: string, excludeDate: string[] = []) {
    return Math.round(this.diffDate(startDate, endDate + ' 23:59:59', 'day')) - excludeDate.length
  }

  public validateInputFromType(type: string, text: string, require: boolean = true, field?: string) {
    if (type) {
      const validate = this.validateList[type.toLowerCase()] as {reg: RegExp, msg: string}
      if (validate) {
        if (text) {
          if ((type === 'cid')) {
            return validate.reg.test(text) && this.checkCid(text) || validate.msg
          } else {
            return validate.reg.test(text) || validate.msg
          }
        }
      } else if (!validate && type === 'Text') {
        return !!text || `${field}จำเป็นต้องกรอก`
      } else {
        return true
      }
    }
    return require ? 'จำเป็นต้องกรอก' : true
  }

  public checkCid(cid: string) {
    cid = cid + ''
    if (cid.length === 13) {
      let last = 0
      const numbers = cid.split('')
      _.forEach(numbers.slice(0, 12), (char, i) => {
        last += (13 - i) * parseInt(char, 10)
      })
      const x = last % 11
      const y = (x > 1) ? 11 : 1
      return (parseInt(numbers[12], 10) === (y - x))
    }
  }

  public getLogoBank(bank: string) {
    return `${process.env.VUE_APP_BASEURL}/public/${bank}.png`
  }

  public timestampToDate(time: number, format: string = 'YYYY-MM-DD HH:mm:ss') {
    return moment.unix(time).format(format)
  }

  public kFormatter(num: number) {
      return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000) + 'k' : Math.sign(num) * Math.abs(num)
  }

  public localeDate(date, format = 'll') {
    if (!date) {
      return ''
    }
    const mom = moment(date).add(543, 'year')
    mom.locale('th')
    return mom.format(format)
  }

  public diffDate(
    startDate: string | moment.Moment,
    endDate: string | moment.Moment = moment(),
    key: unitOfTime.Diff = 'year',
  ) {
    if (typeof startDate === 'string') {
      startDate = moment(startDate)
    }
    if (typeof endDate === 'string') {
      endDate = moment(endDate)
    }
    if (!startDate) {
      return 0
    }
    return endDate.diff(moment(startDate), key, true)
  }

  public mapAddress(text, isDisplay = true) {
    let address = ''
    if (text.address && isDisplay) { address += `${text.address} ` }
    if (text.road) { address += `${text.road} ` }
    if (text.subdistrict) { address += `${text.subdistrict} ` }
    if (text.district) { address += `${text.district} ` }
    if (text.province) { address += `${text.province} ` }
    if (text.postcode) { address += `${text.postcode} ` }
    if (text.country) { address += text.country }
    return address
  }

  public doConvertDateTimeZone(date, time = '', format = '') {
    return _.includes(date, '/')
      ? new Date(`${_.split(date, '/').join('-')}${format}${time}`)
      : new Date(date)
  }

}
